import * as React from 'react';
import { Typography, ListItem, List } from '@mui/material';


function PP() { 
  
  
    return (
        <div className="App-container">  
  <div className="titleTxt">   
  <Typography variant="h3">Privacy Policy for Faug Productions apps</Typography> 
  <Typography variant="h4">(the playtido apps: eartido!, eyetido!, taptido! & scortido!</Typography>
  <Typography variant="h4">(haar, curio collages & seshn it!)</Typography>
  <br/>
<Typography>Effective Date: 06/22/2025</Typography>
<br/>
<Typography variant="body1">We are committed to protecting the privacy of children and ensuring a safe experience for all users. This Privacy Policy explains how we collect, use, and safeguard personal information in compliance with the Children's Online Privacy Protection Act (COPPA). </Typography>

<List sx={{ fontSize:'1rem', listStyleType: 'number' }}>
    <ListItem sx={{ display: 'list-item' }}>Information We Collect:
    <List sx={{ textAlign:'left', listStyleType: 'disc' }}>
        <ListItem sx={{ display: 'list-item' }}>Personal Information: We do not knowingly collect personal information from children under 13 or adults.</ListItem>
        <ListItem sx={{ display: 'list-item' }}>Non-Personal Information: We do not knowlingly collect non-personal information from any user.</ListItem></List></ListItem>
  

<ListItem sx={{ display: 'list-item' }}>Parental Consent:
We require parental consent before the purchase of any recurring subscriptions. Parents can review, update, or delete subscriptions or apps at their own discretion.
</ListItem>
<ListItem sx={{ display: 'list-item' }}>
Third-Party Services:
We do not share personal information with third parties.
</ListItem>
<ListItem sx={{ display: 'list-item' }}>
Changes to This Policy:
We may update this policy from time to time. We will notify you of any significant changes through the app or other means.
</ListItem>
</List>
<Typography>Contact Us:</Typography>
<br/>
<Typography>If you have questions about this Privacy Policy, please contact us at:</Typography>

<Typography>Faug Productions Ltd
<br/>
info@faugproductions.com
<br/>
The Stables,
Corsiehill,
Perth, Scotland
PH2 7BN</Typography>
<br/>
<Typography>Please ensure this policy is reviewed regularly to stay informed about how we protect your information.</Typography>
  </div>
</div>
        );
    }

    export default PP;